import { render, staticRenderFns } from "./loansperuser.vue?vue&type=template&id=593cc9b4"
import script from "./loansperuser.vue?vue&type=script&lang=js"
export * from "./loansperuser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports